<div class="oauth-container" *ngIf="shouldShowSocialLogin()">
  <!-- Facebook sign in button -->
  <!-- TODO (GB-6543): Uncomment below once Facebook has been reactivated -->
  <button
    class="oauth-btn oauth-btn-facebook flex-row"
    *ngIf="(auctionUrlName$ | async) === 'facebook'"
    (click)="facebookSignIn()"
    type="button"
  >
    <fa-icon [icon]="faFacebookF"></fa-icon>
    <div class="span-container flex-row-center">
      <span translate="AUTH.AUTH_FACEBOOK_BUTTON"></span>
    </div>
  </button>

  <!-- google sign in button -->
  <button
    class="oauth-btn oauth-btn-google flex-row"
    *ngIf="googleLoginEnabled$ | async"
    mat-button
    (click)="googleSignIn()"
    type="button"
  >
    <div class="icon-container">
      <img class="oauth-btn-logo" s3File="google_g_logo.svg" alt="Google logo" />
    </div>
    <div class="span-container flex-row-center">
      <span translate="AUTH.AUTH_GOOGLE_BUTTON"></span>
    </div>
  </button>
</div>
